<template>
  <div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Add New Data</vs-button>
        </div>
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ page * per_page - (per_page - 1) }} - {{ row_total - page * per_page > 0 ? page * per_page : row_total }} of {{ row_total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Address</th>
              <th v-if="actor.privilege < 4">User</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="17" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for='(item, index) in data' :key='index'>
              <td>{{ ((page-1)*per_page) + (index+1) }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.address }}</td>
              <td v-if="actor.privilege < 4">{{ item.user.username }}</td>
              <td style="width: 90px">
                <div class="flex">
                  <vx-tooltip text="Edit" position="top">
                    <vs-button :id="`editBtn${item.id}`" type="border" size="small" icon-pack="feather" icon="icon-edit" color="success" class="mr-2 vs-con-loading__container" @click="edit(index)"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Delete" position="top">
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="del(index)"></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="17" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>
      
      <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
        <template>
          <div class="vx-row mb-6">
            <div  v-if="actor.privilege < 4" class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">User</label>
              <v-select @search="searchGeneral" :options="userList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="input.user_id" />
            </div>

            <div v-else class="vx-col sm:w-1/2 w-full">
              <vs-input disabled label="User" class="w-full" v-model="input.user_id.label" />
            </div>


            <div class="vx-col sm:w-1/2 w-full">
              <vs-input label="Name" class="w-full" v-model="input.name" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input label="Phone" class="w-full" v-model="input.phone" />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <vs-textarea label="Address" class="w-full" rows="4" v-model="input.address" />
            </div>
          </div>  

          <div class="vx-row">
            <div class="vx-col w-full ml-auto mt-3">
              <vs-button id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
              <vs-button v-show="action === 'add'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
            </div>
          </div>
        </template>
      </vs-popup>

    </div>
  </div>

</template>

<script>
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';


export default {
  components: {
    vSelect,
    flatPickr,
  },

  data () {
    return {
      actor: {},
      data: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,

      tempId: 0,
      input: {
        user_id: '',
        name: '',
        phone: '',
        address: '',
      },

      userList: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''

    this.$http.get(`${this.$api.endpoint}/user/profile`, {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    }).then(res => {
      this.actor = res.data.message.data

      if(this.actor.privilege == 4) {
        this.input.user_id = {
          label: this.actor.username,
          value: this.actor.id
        }
      }

      this.initTable()
    }).catch(error => {
      this.$gf.httpErrorHandler(error)
    })
  },

  mounted () {
  },

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800);
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = ''
      })
    },

    initTable() {
      this.loading = true
      this.$http.get(`${this.$api.endpoint}/job_order/customer/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.row_total = res.data.message.total
        this.data = res.data.message.data
        this.loading = false
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      let url = this.action === 'add' ? `${this.$api.endpoint}/job_order/customer/add` : `${this.$api.endpoint}/job_order/customer/update/${this.tempId}`

      this.$http.post(url, {
        ...this.input,
        user_id: this.input.user_id ? this.input.user_id.value : ''
      },
      {
        headers:{
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")

        this.notify = res.data.message.split('_').join(' ')

        this.showPopup = false
        this.initTable()
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.$gf.httpErrorHandler(error)
      })
    },

    add() {
      if(this.action === 'edit') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Customer'
      this.showPopup = true
    },

    edit(index) {
      const data = this.data[index]
      this.tempId = data.id
      this.action = 'edit'
      this.popupTitle = 'Edit Customer'

      const userdata = {
        label: data.user.username,
        value: data.user.id
      }

      this.userList = []
      this.userList.push(userdata)

      Object.keys(this.input).map(i => {
        if(i == 'user_id') {
          this.input[i] = userdata
        }

        else this.input[i] = data[i]
      })
      this.showPopup = true
    },

    del(index) {
      const data = this.data[index]
      this.tempId = data.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Customer`,
        text: 'Are you sure want to Delete this Customer ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http.post(`${this.$api.endpoint}/job_order/customer/delete/${this.tempId}`, {

      }, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.initTable()
        this.notify = res.data.message.split('_').join(' ')

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    searchGeneral(search) {
      if(search.length >= 3) {
        this.$http.get(`${this.$api.endpoint}/user/general`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            search: search
          }
        }).then(res => {
          this.userList = res.data.message.data
        }).catch(error => {
          this.$gf.httpErrorHandler(error)
        })
      }else{
        this.userList = []
      }
    },
  },
}

</script>
